// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__22mMz","subheader":"ReorderModal_subheader__2ScpZ","listWrap":"ReorderModal_listWrap__2CPbN"};